import { render, staticRenderFns } from "./yitijiao.vue?vue&type=template&id=d1af8910&scoped=true"
import script from "./yitijiao.vue?vue&type=script&lang=js"
export * from "./yitijiao.vue?vue&type=script&lang=js"
import style0 from "./yitijiao.vue?vue&type=style&index=0&id=d1af8910&prod&scoped=true&lang=css"
import style1 from "./yitijiao.vue?vue&type=style&index=1&id=d1af8910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1af8910",
  null
  
)

export default component.exports